/**
 * Google Analytics 4 - Event Tracking Helper
 * Sends conversion events to GA4 so you can measure CTA effectiveness.
 */

const isGtagAvailable = () =>
  typeof window !== 'undefined' && typeof window.gtag === 'function';

/**
 * Track a click on a primary conversion CTA (WhatsApp, "Solicitar Orçamento", etc.).
 * @param {string} source - Where the click happened (e.g. "hero", "plan-card-1", "faq", "whatsapp-float")
 * @param {string} label  - Optional human-readable label (e.g. plan name)
 */
export const trackWhatsAppClick = (source, label = '') => {
  if (!isGtagAvailable()) return;
  window.gtag('event', 'whatsapp_click', {
    event_category: 'engagement',
    event_label: label || source,
    source,
  });
};

export const trackCTAClick = (cta, source) => {
  if (!isGtagAvailable()) return;
  window.gtag('event', 'cta_click', {
    event_category: 'engagement',
    event_label: cta,
    source,
  });
};

export const trackOutboundLink = (url, label) => {
  if (!isGtagAvailable()) return;
  window.gtag('event', 'click', {
    event_category: 'outbound',
    event_label: label,
    transport_type: 'beacon',
    value: url,
  });
};
